import { Alert, Badge, Button, Card, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useTelegramBot from './model/useTelegramBot';

const TelegramBotTokenBlock = () => {
    const { t } = useTranslation(['Settings', 'common']);
    const { token, setToken, isLoading, isSaving, status, loadStatus, saveToken, askDeactivateBot } = useTelegramBot();

    return (
        <Card>
            <Card.Body>
                <div className="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3">
                    <div>
                        <h6 className="mb-1">{t('telegramBot.tokenBlockTitle')}</h6>
                        <small className="text-muted">{t('telegramBot.tokenBlockSubtitle')}</small>
                    </div>
                    <Badge bg={status?.isWebhookActive ? 'success' : 'secondary'}>
                        {status?.isWebhookActive ? t('telegramBot.status.active') : t('telegramBot.status.inactive')}
                    </Badge>
                </div>

                {status?.hasToken && !status?.isWebhookActive ? (
                    <Alert variant="warning" className="py-2 mb-3">
                        {t('telegramBot.status.warningWebhook')}
                    </Alert>
                ) : null}

                <Form.Group className="mb-3">
                    <Form.Label>{t('telegramBot.tokenLabel')}</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder={t('telegramBot.tokenPlaceholder')}
                        value={token}
                        disabled={isLoading || isSaving}
                        onChange={(e) => setToken(e.currentTarget.value.trim())}
                    />
                    <Form.Text className="text-muted">
                        {status?.hasCustomToken
                            ? t('telegramBot.currentSource.db')
                            : t('telegramBot.currentSource.env')}
                    </Form.Text>
                </Form.Group>

                <div className="d-flex flex-wrap gap-2 align-items-center">
                    <Button onClick={saveToken} disabled={isLoading || isSaving}>
                        {isSaving ? t('common:buttons.saving') : t('common:buttons.save')}
                    </Button>
                    <Button variant="light" onClick={loadStatus} disabled={isLoading || isSaving}>
                        {t('telegramBot.refresh')}
                    </Button>
                    <Button
                        variant="outline-danger"
                        onClick={askDeactivateBot}
                        disabled={isLoading || isSaving || !status?.hasToken}
                    >
                        {t('telegramBot.deactivate.btn')}
                    </Button>
                </div>

                {status?.isWebhookActive ? (
                    <div className="mt-3">
                        <small className="text-success fw-semibold">{t('telegramBot.status.webhookInstalled')}</small>
                    </div>
                ) : (
                    <>
                        {!!status?.expectedWebhookUrl && (
                            <div className="mt-3">
                                <small className="text-muted d-block">{t('telegramBot.expectedWebhook')}</small>
                                <code>{status.expectedWebhookUrl}</code>
                            </div>
                        )}
                        {!!status?.webhookUrl && (
                            <div className="mt-2">
                                <small className="text-muted d-block">{t('telegramBot.currentWebhook')}</small>
                                <code>{status.webhookUrl}</code>
                            </div>
                        )}
                        {!!status?.lastErrorMessage && (
                            <div className="mt-2">
                                <small className="text-muted d-block">{t('telegramBot.lastError')}</small>
                                <code>{status.lastErrorMessage}</code>
                            </div>
                        )}
                    </>
                )}
            </Card.Body>
        </Card>
    );
};

export default TelegramBotTokenBlock;
